"use strict";
exports.__esModule = true;
exports.Shapes = void 0;
exports.Shapes = [
    { x1: 0, y1: 0.25, x2: 0.25, y2: 0.125, x3: 0.25, y3: 0.375 },
    { x1: 0, y1: 0, x2: 0.25, y2: 0.125, x3: 0, y3: 0.25 }
];
